var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _ellipse, _path14, _path15, _path16, _circle2, _path17, _rect, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationLife(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.229 50.0596C230.798 78.6657 224.868 121.546 211.843 156.543C198.872 191.492 178.862 218.532 152.644 230.145C126.482 241.756 94.1658 237.923 69.4455 223.869C44.6683 209.81 27.4843 185.545 26.0997 162.43C24.6582 139.386 39.0705 117.547 55.2557 89.4961C71.4408 61.4451 89.51 27.1723 120.053 17.1744C150.648 7.17653 193.66 21.5155 212.229 50.0596Z",
    fill: "#E7EEF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 154L100.5 203",
    stroke: "#62736D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 154L132.5 203",
    stroke: "#62736D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 154H83.7756L53.5 82H79.2244L109.5 154Z",
    fill: "#62736D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 116V188",
    stroke: "#62736D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 116V199",
    stroke: "#62736D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 203.442L152.277 204L152.5 203.003L143.683 200L139.592 200.131L139.5 203.442Z",
    fill: "#3A4944"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 187.265L139.592 200.131L143.683 200C143.683 200 148.7 183.761 150.5 175",
    fill: "#56CAD8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 125.552C109.584 125.146 122.693 123 136.994 123C153.48 123 160.532 124.854 162.22 126.512C163.908 128.171 157.453 153.049 156.46 155",
    fill: "#56CAD8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7158 122C78.5272 124.183 78.8561 124.58 78.5272 131.922C77.3386 158.512 115.375 154.345 140.931 161.489C134.393 181.928 120.005 200.008 120.005 201L124.404 203.66C134.508 198.5 165.918 161.558 165.496 155.734C164.703 144.82 113.592 125.572 106.856 125.572",
    fill: "#74D5DE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.325 92C125.218 97.0114 128.592 107.793 128.989 107.793C143.477 107.793 157.37 111.586 158.363 111.586C159.355 111.586 161.34 110.189 162.134 110.189C162.927 110.189 166.5 111.786 166.5 112.585C166.5 113.383 124.027 112.784 123.034 112.784C122.141 111.886 114.5 104.598 114.5 103.4",
    fill: "#FFD8C1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0644 115.227C83.5995 95.5703 98.9794 67.1769 102.331 64C109.233 64 118.5 79.6859 118.5 89.018C118.5 99.5414 108.848 124.619 106.866 125.949C103.317 128.332 83.9938 126.545 78.8672 121.78C77.9385 120.918 79.0644 115.227 79.0644 115.227Z",
    fill: "#9E80FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 54.5,
    r: 2.5,
    fill: "#FFD8C1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.599 66.4749C101.431 67.0228 108.307 68.3957 108.823 67.8902C108.823 66.8793 108.823 62.4312 109.442 60.8137C110.062 59.1962 105.508 54.465 104.173 54C102.837 56.1634 99.5344 53.1306 100.773 56.1634C102.011 59.1962 102.837 62.4312 101.599 66.4749Z",
    fill: "#FFCBAD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108,
    cy: 52.5,
    rx: 5.5,
    ry: 10.5,
    fill: "#FFD8C1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9331 43.3006C92.0276 43.3006 90.8465 38 83.9567 38C78.248 38 76.2106 41.8302 73.7205 43.6933C71.3583 45.4601 62.5 47.6196 62.5 57.2393C62.5 63.9141 67.6181 70 73.3268 70C80.4134 70 87.3032 61.1656 94.7835 61.1656C97.9331 61.1656 97.3425 62.3436 101.083 62.3436C102.461 62.3436 102.461 61.362 102.461 60.9693C102.461 60.5767 103.051 59.7914 103.051 59.0061C103.051 56.6503 101.083 57.6319 101.083 54.4908C101.083 53.1166 102.461 52.188 103.839 52.188C105.217 52.188 111.122 47.227 111.122 43.6933C111.516 44.0859 112.106 45.8528 112.106 46.0491C112.303 46.0491 112.5 45.0675 112.5 44.6748C112.5 40.7485 108.563 39.7669 107.185 39.7669C104.035 39.7669 102.657 43.3006 97.9331 43.3006Z",
    fill: "#DF684E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.083 75.3806C97.091 78.4243 101.472 100.486 105.166 101.848C108.86 103.21 121.304 95.0366 121.498 92.1174C121.693 89.1982 105.166 72.2667 101.083 75.3806Z",
    fill: "#B098FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.55 94.5919C120.142 95.3837 123.698 100.332 123.698 100.332C125.673 100.332 132.784 99.9362 156.686 93.0084C157.476 92.8105 159.339 96.1576 158.069 96.9672C153.723 99.7383 124.093 113 117.574 113C115.994 113 107.5 102.509 107.5 101.124",
    fill: "#FFD8C1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 94,
    r: 3,
    fill: "#FFD8C1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 204.617L130.541 214L131.5 213.043L124.404 203.66L120.005 201L117.5 204.617Z",
    fill: "#3A4944"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.5,
    y: 113,
    width: 83,
    height: 4,
    fill: "#62736D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 116V188",
    stroke: "#62736D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 116V199",
    stroke: "#62736D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 154L78.5 203",
    stroke: "#62736D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLife);
export default __webpack_public_path__ + "static/media/IllustrationLife.a644537b9afced21c8ebe47a08bb5225.svg";
export { ForwardRef as ReactComponent };